import {
  QuestionLevelDangerousChange,
  QuestionMissingChange,
  QuestionNotInTemplateChange,
  InstanceFieldOptionsWouldBeLostChange,
  QuestionTypeChangedChange,
  InstanceFieldOptionRemovedChange,
  TemplateFieldOptionRemovedChange,
  QuestionConditionalLogicChangedChange,
  QuestionFieldOptionsChangedChange,
  InstanceConditionalWasRemovedChange,
  TemplateConditionalWasRemovedChange,
  QuestionInstanceWasEditedChange,
  InvalidConditionalReferenceChange,
} from "../../types/syncCheckResult";

export const isQuestionMissingChange = (
  change: QuestionLevelDangerousChange
): change is QuestionMissingChange => {
  return change.type === "QUESTION_IS_MISSING_IN_INSTANCE";
};

export const isQuestionNotInTemplateChange = (
  change: QuestionLevelDangerousChange
): change is QuestionNotInTemplateChange => {
  return change.type === "QUESTION_NOT_IN_TEMPLATE";
};

export const isInstanceFieldOptionsWouldBeLostChange = (
  change: QuestionLevelDangerousChange
): change is InstanceFieldOptionsWouldBeLostChange => {
  return change.type === "INSTANCE_FIELD_OPTIONS_WOULD_BE_LOST";
};

export const isQuestionTypeChangedChange = (
  change: QuestionLevelDangerousChange
): change is QuestionTypeChangedChange => {
  return change.type === "QUESTION_TYPE_CHANGED";
};

export const isFieldOptionRemovedChange = (
  change: QuestionLevelDangerousChange
): change is InstanceFieldOptionRemovedChange | TemplateFieldOptionRemovedChange => {
  return change.type === "QUESTION_INSTANCE_FIELD_OPTION_REMOVED" ||
         change.type === "QUESTION_TEMPLATE_FIELD_OPTION_REMOVED";
};

export const isInstanceFieldOptionRemovedChange = (
  change: QuestionLevelDangerousChange
): change is InstanceFieldOptionRemovedChange => {
  return change.type === "QUESTION_INSTANCE_FIELD_OPTION_REMOVED";
};

export const isTemplateFieldOptionRemovedChange = (
  change: QuestionLevelDangerousChange
): change is TemplateFieldOptionRemovedChange => {
  return change.type === "QUESTION_TEMPLATE_FIELD_OPTION_REMOVED";
};

export const isQuestionConditionalLogicChangedChange = (
  change: QuestionLevelDangerousChange
): change is QuestionConditionalLogicChangedChange => {
  return change.type === "QUESTION_CONDITIONAL_LOGIC_CHANGED";
};

export const isQuestionConditionalWasRemovedChange = (
  change: QuestionLevelDangerousChange
): change is InstanceConditionalWasRemovedChange | TemplateConditionalWasRemovedChange => {
  return change.type === "QUESTION_INSTANCE_CONDITIONAL_WAS_REMOVED" ||
         change.type === "QUESTION_TEMPLATE_CONDITIONAL_WAS_REMOVED";
};

export const isInstanceConditionalWasRemovedChange = (
  change: QuestionLevelDangerousChange
): change is InstanceConditionalWasRemovedChange => {
  return change.type === "QUESTION_INSTANCE_CONDITIONAL_WAS_REMOVED";
};

export const isTemplateConditionalWasRemovedChange = (
  change: QuestionLevelDangerousChange
): change is TemplateConditionalWasRemovedChange => {
  return change.type === "QUESTION_TEMPLATE_CONDITIONAL_WAS_REMOVED";
};

export const isQuestionFieldPropertiesChangedChange = (
  change: QuestionLevelDangerousChange
): change is QuestionFieldOptionsChangedChange => {
  return change.type === "QUESTION_FIELD_PROPERTIES_CHANGED";
};

export const isQuestionInstanceWasEditedChange = (
  change: QuestionLevelDangerousChange
): change is QuestionInstanceWasEditedChange => {
  return change.type === "QUESTION_WAS_EDITED";
};

export const isInvalidConditionalReferenceChange = (
  change: QuestionLevelDangerousChange
): change is InvalidConditionalReferenceChange => {
  return change.type === "INVALID_CONDITIONAL_REFERENCE";
};